/**
 * This page will display the story associated to the ID in the page's route.
 */
import { GetStaticPaths, GetStaticProps } from "next";
import StoryPage, {
  getStoryStaticPaths,
  getStoryStaticProps,
} from "@dreambigger/stories/src/components/views/story";

// Get the static paths for each story that we want to prerender.
export const getStaticPaths: GetStaticPaths = getStoryStaticPaths;

// Get data to statically generate the page for the story.
export const getStaticProps: GetStaticProps = getStoryStaticProps;

export default StoryPage;
